export enum EConfigEventType {
	PlatformReady,
	ConfigReady,
	StaticConfigReady
}